import { render, staticRenderFns } from "./PaymentDashboardMessageItem.vue?vue&type=template&id=b1c97d52&scoped=true&"
import script from "./PaymentDashboardMessageItem.vue?vue&type=script&lang=js&"
export * from "./PaymentDashboardMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDashboardMessageItem.vue?vue&type=style&index=0&id=b1c97d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c97d52",
  null
  
)

export default component.exports